import { z } from "zod";

import { listSearchBaseShape, searchTextSchema } from "/src/router/searchSchemas";

export const mUserListSearchSchema = z.object({
  ...listSearchBaseShape,
  fullName: searchTextSchema,
  phoneNumber: searchTextSchema,
  email: searchTextSchema,
  id: searchTextSchema,
  detailStatus: z.enum(["detail", "edit", "add", "addPerson"]).optional().catch(undefined),
});

export type MUserListSearch = z.infer<typeof mUserListSearchSchema>;

export const mUserListSearchFields = ["fullName", "phoneNumber", "email"] as const;

export type MUserListSearchField = (typeof mUserListSearchFields)[number];
export type MUserListSearchFormValues = Pick<MUserListSearch, MUserListSearchField>;

function createMUserSearchValues(
  getValue: (field: MUserListSearchField) => string | undefined,
): MUserListSearchFormValues {
  return mUserListSearchFields.reduce((values, field) => {
    values[field] = getValue(field);
    return values;
  }, {} as MUserListSearchFormValues);
}

export const emptyMUserListSearch = createMUserSearchValues(() => undefined);

export function getMUserSearchValues(search: MUserListSearch): MUserListSearchFormValues {
  return createMUserSearchValues((field) => search[field]);
}

export function getMUserSearchPatch(
  values: Partial<Record<MUserListSearchField, string | undefined>>,
): MUserListSearchFormValues {
  return createMUserSearchValues((field) => values[field] || undefined);
}
